module.exports = ".imageClass{\n    width: 200px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/par_employees/par_employees.component.css
// module id = ./src/app/components/par_employees/par_employees.component.css
// module chunks = main